import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';

import { RootState } from '@root/app.state';
import * as CoreActions from '@core/core.actions';
import { RouteGuard } from '@platform/routing/route.guard';
import { selectTemplateActualisation } from '@core/core.selectors';
import { resourceLoadSucceeded } from '@platform/shared/resource.state';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements RouteGuard {
  constructor(private store$: Store<RootState>) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return await this.loadAndWait(route);
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot): Promise<boolean> {
    return await this.loadAndWait(childRoute.parent!);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private async loadAndWait(route: ActivatedRouteSnapshot): Promise<boolean> {
    this.store$.dispatch(CoreActions.getLatestTemplateActualisations());

    return await resourceLoadSucceeded(this.store$, selectTemplateActualisation);
  }
}
